import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  return config;
});

// Redirect to /unauthorized on 403 Forbidden to handle multi-role session contamination elegantly.
// Also retry GET requests once on a network error/timeout — GETs are safe to
// retry (idempotent); POST/PATCH/DELETE are never retried here since a lost
// response doesn't mean the write didn't happen server-side (e.g. payments).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      window.location.href = "/unauthorized";
      return Promise.reject(error);
    }
    const config = error.config;
    const isNetworkOrTimeout = !error.response;
    if (config && isNetworkOrTimeout && config.method === "get" && !config._retried) {
      config._retried = true;
      return api(config);
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatError(detail) {
  if (!detail) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
